import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import DictionariesCountryModel, {
  UpdateDictionariesCountryModel,
  CreateDictionariesCountryModel,
} from "../../../viewModels/Dictionaries/DictionariesCountryModel";

import { DigitalLogistCarrierBasicInfoModel } from "../../../viewModels/Carriers/DigitalLogistCarrierModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  countries: Array<DictionariesCountryModel>;

  carriers: Array<DigitalLogistCarrierBasicInfoModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;
  searchFilterValue: string;

  countryIdToEdit: number;
  isEditCountryDrawerOpen: boolean;
  isEditCountryDrawerLoading: boolean;
} = {
  loading: true,
  loadingData: true,

  countries: undefined!,

  carriers: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,
  searchFilterValue: "",

  countryIdToEdit: undefined!,
  isEditCountryDrawerLoading: false,
  isEditCountryDrawerOpen: false,
};

const dictionariesCountriesSlice = createSlice({
  name: "dictionariesCountries",
  initialState,
  reducers: {
    loadCountries(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadCountriesSuccess(state, action: PayloadAction<{ countries: Array<DictionariesCountryModel>; total: number }>) {
      const { countries, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.countries = countries;
      state.total = total;
    },
    loadCountriesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = {
        key: action.payload.sort.key,
        order: action.payload.sort.order,
      };
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditCountryDrawer(state, action: PayloadAction<number | undefined>) {
      state.countryIdToEdit = action.payload!;
      state.isEditCountryDrawerOpen = true;
    },
    closeEditCountryDrawer(state) {
      if (!state.isEditCountryDrawerLoading) {
        state.countryIdToEdit = undefined!;
        state.isEditCountryDrawerOpen = false;
      }
    },

    createCountry(state, _action: PayloadAction<CreateDictionariesCountryModel>) {
      state.isEditCountryDrawerLoading = true;
    },
    createCountrySuccess(state) {
      state.isEditCountryDrawerLoading = false;
      state.isEditCountryDrawerOpen = false;
    },
    createCountryError(state) {
      state.isEditCountryDrawerLoading = false;
      state.isEditCountryDrawerOpen = false;
    },

    updateCountry(state, _action: PayloadAction<UpdateDictionariesCountryModel>) {
      state.isEditCountryDrawerLoading = true;
    },
    updateCountrySuccess(state, action: PayloadAction<UpdateDictionariesCountryModel>) {
      state.isEditCountryDrawerLoading = false;
      state.isEditCountryDrawerOpen = false;
      const index = state.countries.findIndex((x) => x.id === action.payload.id);
      state.countries[index] = action.payload;
    },
    updateCountryError(state) {
      state.isEditCountryDrawerLoading = false;
      state.isEditCountryDrawerOpen = false;
    },

    loadCarriers() {},
    loadCarriersSuccess(state, action: PayloadAction<Array<DigitalLogistCarrierBasicInfoModel>>) {
      state.carriers = action.payload;
    },
  },
});

export default dictionariesCountriesSlice;
